<template>
  <header class="admin-header">
    <div class="header-left">
      <h1 style="text-transform: capitalize">
        <!-- {{ $route.params.slug || $route.path.split("/").filter(Boolean).pop() }} -->
        My Dashboard
      </h1>
    </div>
    <div class="header-right">
      <!-- <input type="text" placeholder="Search..." class="search-input" />
        <button class="icon-btn">
          <i class="fa fa-bell"></i>
          <span class="notification-badge">4</span>
        </button>
        <button class="icon-btn">
          <i class="fa fa-cog"></i>
        </button> -->
      <button @click="handleLogout" class="logout-btn">Logout</button>
    </div>
  </header>
</template>

<script>
import { mapActions } from "vuex";

export default {
  methods: {
    ...mapActions(["logout"]),
    handleLogout() {
      this.logout();
      this.$router.push("/login");
    },
  },
};
</script>

<style scoped>
.admin-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  padding: 15px 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.header-left {
  display: flex;
  flex-direction: column;
}

.header-left h1 {
  font-size: 20px;
  margin: 0;
  font-weight: bold;
  color: #344767;
}

.header-left span {
  color: #7d879c;
  font-size: 14px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 15px;
}

.search-input {
  padding: 8px 15px;
  border: 1px solid #ddd;
  border-radius: 5px;
}

.icon-btn {
  position: relative;
  background: none;
  border: none;
  cursor: pointer;
}

.icon-btn i {
  font-size: 18px;
  color: #344767;
}

.notification-badge {
  position: absolute;
  top: -5px;
  right: -5px;
  background: red;
  color: white;
  border-radius: 50%;
  font-size: 12px;
  width: 18px;
  height: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.logout-btn {
  padding: 8px 15px;
  background-color: #344767;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.logout-btn:hover {
  background-color: #2d3e50;
}
</style>
